import { render, staticRenderFns } from "./SuggestionItem.vue?vue&type=template&id=f4b3e930&scoped=true&"
import script from "./SuggestionItem.vue?vue&type=script&lang=js&"
export * from "./SuggestionItem.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionItem.vue?vue&type=style&index=0&id=f4b3e930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b3e930",
  null
  
)

export default component.exports